import { request } from './api';
import config from '../config/index';
export default {
  getPictureItemsByCondition(seriesid, specid, pageindex, typeids) {
    return request({
      type: 'get',
      dataType: 'json',
      url: `${config.dealerCloudVrapi}/vrapi/car/pictures?seriesId=${seriesid}&specId=${specid}&typeIds=${typeids}&pageIndex=${pageindex}`,
      data: {},
      transformResponse: function (data) {
        if (data) {
          return { returncode: 0, message: '', result: data };
        } else {
          return {
            returncode: 1,
            message: '获取图片列表失败',
            result: data,
          };
        }
      },
    });
  },
  getSpecParameters(specId) {
    return request({
      type: 'get',
      dataType: 'json',
      url: `${config.dealerCloudVrapi}/vrapi/car/params?specId=${specId}`,
      data: {},
    });
  },
};
